// Reine Regeln für Vorgangsdokumente in der Kundenakte (P6, PO 14.09.2026).
//
// Bewusst ohne React und Fetch, damit die Regeln testbar sind, deren Wegfall
// in der Oberfläche NICHT auffiele: der Chip-Text und das Zähler-Label.
// DocumentsSection ist der einzige Aufrufer. (Die Gruppe „Vorgänge" an der
// Wurzel ist seit dem 28.09.2026 der Ordner „KMVS › Vorgänge", s. kmvsOrdner.ts.)

import type { DocumentDto } from "../../../services/documentService";

/** Chip-Text hinter dem Dateinamen; `null` ohne Vorgangsbezug. Alte Vorgänge
 *  ohne Nummer fallen auf die Id zurück — nie „aus Vorgang null". */
export const vorgangsTag = (vorgang: DocumentDto["vorgang"]): string | null =>
  vorgang ? `aus Vorgang ${vorgang.vorgangNbr ?? `#${vorgang.id}`}` : null;

/** Tooltip des Chips: Vorgangstitel, wenn es einen gibt, plus die Handlung. */
export const vorgangsTagTitel = (vorgang: DocumentDto["vorgang"]): string | null =>
  vorgang ? (vorgang.titel ? `${vorgang.titel} — Vorgang öffnen` : "Vorgang öffnen") : null;

/**
 * Zähler-Label beim Ordner-Browsing. Der Server-`total` kennt nur die
 * Alt-Akten-Dateien der Ebene; an der Wurzel zählen die Vorgangsdokumente
 * mit. Greift der Deckel (mehr Vorgangsdokumente als geladen), sagt das Label,
 * dass die flache Liste den Rest hat — sonst fehlten Dateien kommentarlos.
 */
export const ordnerZaehlerLabel = (args: {
  total: number;
  wurzel: boolean;
  vorgangTotal: number;
  vorgangGeladen: number;
}): string => {
  const anzahl = args.total + (args.wurzel ? args.vorgangTotal : 0);
  const rest = args.wurzel ? Math.max(0, args.vorgangTotal - args.vorgangGeladen) : 0;
  const basis = `${anzahl.toLocaleString("de-DE")} ${anzahl === 1 ? "Datei" : "Dateien"} in diesem Ordner`;
  return rest > 0
    ? `${basis} — ${rest.toLocaleString("de-DE")} weitere aus Vorgängen nur in der flachen Liste`
    : basis;
};
